import { Component } from "@angular/core";
import {
  Event,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from "@angular/router";
import { environment } from "environments/environment";
import { AuthService } from "./core/services/auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "video_manager_vama";

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
        ("start");
        this.activateOptions();
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        this.activateOptions();
        // layoutComponent.insertTabs();
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator
        // Present error to user
        console.log(event.error);
      }
    });
  }

  ngOnInit() {}

  activateOptions() {
    let typeUser = AuthService.getFromStorage(
      environment.storageTypeUserNameApi
    );
    if (typeUser == "clientuserNoAdmin") {
      const rawPermissionRoutes = AuthService.getFromStorage(
        environment.storageUserPermissionsNameApi
      );
      const permissionRoutes = rawPermissionRoutes
        ? JSON.parse(rawPermissionRoutes)
        : null;

      if (!permissionRoutes || typeof permissionRoutes !== "object") {
        return "";
      }

      const keys = Object.keys(permissionRoutes);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        for (let itemChildrenRoute of permissionRoutes[key]) {
          if (itemChildrenRoute !== "") {
            $("." + itemChildrenRoute).removeClass("no-granted");
          }
        }
      }
    }
    return "";
  }
}
